<div *ngIf="showAlert" class="alertContainer">
    <div class="card">
        <div class="alertIcon">
            <img src="../../../assets/images/alert_excl.svg">
        </div>
        <div class="card-body" style="padding-top: 0;">
            <div class="textCenter boldFont">
                <span>Payment Issue - Action Needed</span>
            </div>
            <div class="textCenter martop10px">
                <span>We had trouble processing your last payment. We'll automatically re-attempt the charge, but please update your payment details within {{daysLeft}} day(s) to avoid any interruption to your plan.</span>
            </div>
            <div class="textCenter martop10px" *ngIf="source !== 'inputs'">
                <a routerLink="/pricingPlans" class="btn upgradeBtn">Update Payment Method</a>
            </div>
        </div>
    </div>
</div>
